import { render } from "./ContractDetails.vue?vue&type=template&id=0f69cfa1&scoped=true"
import script from "./ContractDetails.vue?vue&type=script&lang=js"
export * from "./ContractDetails.vue?vue&type=script&lang=js"

import "./ContractDetails.vue?vue&type=style&index=0&id=0f69cfa1&scoped=true&lang=css"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f69cfa1"]])

export default __exports__